export const getCacheEntry = (key: string): string | null => {
  try {
    const item = localStorage.getItem(key)
    if (!item) {
      return null
    }

    const { value, expiry } = JSON.parse(item)
    if (Date.now() > expiry) {
      localStorage.removeItem(key)
      return null
    }
    return value
  } catch {
    return null
  }
}

export const setCacheEntry = (
  key: string,
  value: string,
  minutes: number,
): void => {
  try {
    const item = { value, expiry: Date.now() + minutes * 60 * 1000 }
    localStorage.setItem(key, JSON.stringify(item))
  } catch {
    // NOOP: Do nothing if localStorage fails
  }
}
